export const truncate = (text: string, limit = 25, completeWords = false, ellipsis = '…'): string => {
  if (completeWords) {
    limit = text.substring(0, limit).lastIndexOf(' ');
  }

  return text.length > limit ? `${text.substring(0, limit)}${ellipsis}` : text;
};
